import { useEffect } from 'react';
import { useTestBlockSelection } from '@/components/preview/block-selection/TestBlockSelectionContext';
import { useReportWizard } from '../context/ReportWizardContext';

/**
 * Selecting a block in the document drills the tools panel into that block's
 * group. This is what teaches the two-level model: the first time anyone clicks
 * a table for any reason, the panel changes in front of them.
 *
 * Deliberately one-way. Clearing the selection does not pop the panel back — a
 * panel that changes level as the user clicks around the canvas is worse than a
 * crowded one, so leaving is only ever the back crumb or Escape.
 *
 * Renders nothing; it exists to sit inside `TestBlockSelectionProvider`, which
 * CreateReport itself is outside of.
 */
export const PanelScopeSync = () => {
    const { selectedIds } = useTestBlockSelection();
    const { scopePanelToBlock } = useReportWizard();

    useEffect(() => {
        // Only an unambiguous selection names a group. A marquee across several
        // blocks leaves the panel wherever it was.
        if (selectedIds.size !== 1) return;

        const [realId] = selectedIds;
        scopePanelToBlock(realId);
    }, [selectedIds, scopePanelToBlock]);

    return null;
};
